import Store from "../store";
import { channelDetails, name } from "./env";
import { _set_cart_data } from "../store/actions/login_actions";
import { API } from "../request/api";
import { Note } from "../helbest";
import { stringify } from "query-string";
import { countries } from "../constants/countries-code"; 


export const calculator = (newData) => {
  let cart_credit = 0;
  let total_amount = 0;
  let total_quantity = 0;
  let payable_amount = 0;
  let discount_amount = 0;
  let total_usable_credit = 0;
  let tax_amount = 0;
  let cart = [...new Set(Store.getState().Cart.map(({ product }) => product))];

  cart.map((x) => {
    total_quantity += x.quantity;
    total_amount += x.quantity * x.price;
    payable_amount +=
      x.quantity * x.payable_amount + Number(x.quantity) * Number(x.tax);
    discount_amount += x.quantity * x.discount_amount;
    tax_amount += Number(x.quantity) * Number(x.tax);
    // total_usable_credit += x.quantity * x.usable_credit_amount;
    return 0;
  });

  cart_credit = Store.getState().Login.credit
    ? Math.min(0, Store.getState().Login.credit, payable_amount)
    : Math.min(0, payable_amount);
  payable_amount = Math.max(payable_amount - cart_credit, 0);

  Store.dispatch(
    _set_cart_data(
      cart_credit,
      newData
        ? newData
        : {
            total_amount: handleShowDecimalPrices(total_amount),
            total_quantity,
            payable_amount: handleShowDecimalPrices(payable_amount),
            discount_amount: handleShowDecimalPrices(discount_amount),
            total_usable_credit,
            tax_amount: handleShowDecimalPrices(tax_amount),
          }
    )
  );
};

export const timeAgo = (date) => {
  const time = Math.floor(
    (new Date().valueOf() - new Date(date).valueOf()) / 1000
  );
  const { interval, unit } = calculateTimeDifference(time);
  const suffix = interval === 1 ? "" : "s";
  return `${interval} ${unit}${suffix} ago`;
};

const calculateTimeDifference = (time) => {
  for (let { label, seconds } of units) {
    const interval = Math.floor(time / seconds);
    if (interval >= 1) {
      return {
        interval: interval,
        unit: label,
      };
    }
  }
  return {
    interval: 0,
    unit: "",
  };
};

const units = [
  { label: "year", seconds: 31536000 },
  { label: "month", seconds: 2592000 },
  { label: "week", seconds: 604800 },
  { label: "day", seconds: 86400 },
  { label: "hour", seconds: 3600 },
  { label: "minute", seconds: 60 },
  { label: "second", seconds: 1 },
];

export const Comma = (value) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const TComma = (value) => {
  return Comma(~~value);
};

export const DashingCreditCard = (value) => {
  try {
    return value
      .replace(/-/g, "")
      .replace(/(.{4})/g, "$1 ")
      .trim()
      .replace(/\s/g, "-");
  } catch {
    if (value) {
      return value;
    }
    return "-";
  }
};

export const RemoveDashedCreditCard = (value) => {
  return value.toString().replace(/-/g, "");
};

export const convertFaToEn = (txt) => {
  const PER_MATCH = /[۰۱۲۳۴۵۶۷۸۹]/g;
  const replacePer = (char) => char.charCodeAt(0) - 1776 + "";

  if (!txt) return "";
  return txt.replace(PER_MATCH, replacePer);
};

export const convertEnToFa = (str) => {
  const EN_NUM = /[0-9]/g;
  const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

  if (typeof str === "string") {
    return str.replace(EN_NUM, (w) => persianDigits[+w]);
  }

  return str || "";
};

export const rangeGenerator = (highEnd, lowEnd) => {
  let list = [];
  for (let i = highEnd; i >= lowEnd; i--) {
    list.push(i);
  }
  return list;
};

export const isDigit = (value) => {
  value = value.replaceAll("۰", "0");
  value = value.replaceAll("۱", "1");
  value = value.replaceAll("۲", "2");
  value = value.replaceAll("۳", "3");
  value = value.replaceAll("۴", "4");
  value = value.replaceAll("۵", "5");
  value = value.replaceAll("۶", "6");
  value = value.replaceAll("۷", "7");
  value = value.replaceAll("۸", "8");
  value = value.replaceAll("۹", "9");
  const reg = /^[\d۰۱۲۳۴۵۶۷۸۹]*?$/;
  return !isNaN(value) && reg.test(value);
};

export const isNumber = (value) => {
  return !isNaN(parseFloat(value)) && !isNaN(value - 0);
};

// export const displayErrorByFields = {
//   "email": "email is not"
// }

export const showAllErrors = (errors) => {
  errors.forEach(({ message, field }) => {
    Note.error(`${message} - ${field}`);
  });
};

export const mapEdgesToNodes = (edges, transformer) => {
  if (edges) {
    return edges?.map((edge) =>
      transformer ? transformer(edge.node) : edge.node
    );
  }

  return [];
};

export const getCategorySortedParams = (params) => {
  return [
    params.category_id || null,
    params.sub_category_id || null,
    params.sub_category_id_2 || null,
    params.sub_category_id_3 || null,
    params.sub_category_id_4 || null,
    params.sub_category_id_5 || null,
  ].filter((catItem) => catItem !== null);
};

export const handleFilterProductAttributes = (
  queries = {},
  attributes = []
) => {
  return Object.entries(queries)
    .filter(([key]) => attributes.includes(key))
    .map(([key, value]) => ({
      slug: key,
      values: value && value.split(","),
    }));
};

export function stringifyQs(params, arrayFormat) {
  return stringify(params, {
    arrayFormat: arrayFormat || "indices",
  });
}

export const calculateDiscountPercentageByDiscountAmount = (
  discount_amount,
  total_amount
) => {
  const discount_percentage = discount_amount
    ? (discount_amount * 100) / total_amount
    : 0;
  return handleShowDecimalPrices(discount_percentage);
};

export const calculateDiscountPercentageByDiscountAmountToFixed = (
  discount_amount,
  total_amount
) => {
  const discount_percentage = discount_amount
    ? (discount_amount * 100) / total_amount
    : 0;
  return Number(toFixedNumber(discount_percentage));
};

export const handleShowDecimalPrices = (num = 0) => {
  const numberWithDecimal = Math.floor(num * 10000) / 10000;

  return numberWithDecimal % 1 === 0
    ? numberWithDecimal
    : toFixedNumber(numberWithDecimal) % 1 === 0
    ? Math.ceil(toFixedNumber(numberWithDecimal))
    : toFixedNumber(numberWithDecimal);
};
export const CapitalizeString = (str = "") =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const displayRichText = (jsonString) => {
  const jsonObj = JSON.parse(jsonString);
  let htmlContent = "";

  jsonObj.blocks.forEach((block) => {
    switch (block.type) {
      case "paragraph":
        htmlContent += `<p>${formatText(block.data.text)}</p>`;
        break;
      case "list":
        const listTag = block.data.style === "unordered" ? "ul" : "ol";
        htmlContent += `<${listTag}>`;
        block.data.items.forEach((item) => {
          htmlContent += `<li>${formatText(item)}</li>`;
        });
        htmlContent += `</${listTag}>`;
        break;
      default:
        console.log("Unknown block type");
    }
  });

  return { __html: htmlContent };
};

const formatText = (text) => {
  // Basic text formatting - implement more complex logic as needed
  // Check for strikethrough text and change color
  if (text.includes("<s>")) {
    return text.replace(
      /<s>(.*?)<\/s>/g,
      '<span style="color: #868686;"><s>$1</s></span>'
    );
  }
  return `<p>${text}</p>`;
};

export function convertUTCToLocalTime(utcTimeString) {
  const [hours, minutes] = utcTimeString.split(":");
  const utcDate = new Date(
    Date.UTC(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      hours,
      minutes
    )
  );

  const localHours = utcDate.getHours().toString().padStart(2, "0");
  const localMinutes = utcDate.getMinutes().toString().padStart(2, "0");

  return `${localHours}:${localMinutes}`;
}

export function getMetadataValueByKey(dataArray, searchKey) {
  // Loop through the array
  for (let i = 0; i < dataArray.length; i++) {
    // Check if the key matches the searchKey
    if (dataArray[i].key === searchKey) {
      // Return the value if a match is found
      return dataArray[i].value;
    }
  }
  // Return null or undefined if no match is found
  return null;
}

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}/${month}/${day}`;
};

export function toFixedNumber(num = 0) {
  try {
    const { channel } = Store.getState().Login;
    const numValue = Number(num);

    if (Number.isNaN(numValue)) return 0;

    const precision = channelDetails[channel].precision || 3;
    return numValue.toFixed(precision);
  } catch (error) {
    console.warn("toFixedNumber error:", error);
    return Number(num);
  }
}

export function dateFormatter(date, options) {
  return new Intl.DateTimeFormat("en-US", options).format(new Date(date));
}

export function calculateRemainingTime(sentTime, expiredCount) {
  const now_sec = new Date().getTime() / 1000;
  const created_at_sec = new Date(sentTime).getTime() / 1000;
  return created_at_sec + expiredCount - now_sec;
}

export function slugify(str) {
  return str
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}

/**
 * Truncate text to a maximum length and add ellipsis if needed
 * @param {string} text - Text to truncate
 * @param {number} maxLength - Maximum length before truncation (default: 10)
 * @returns {string} Truncated text with ellipsis if longer than maxLength
 */
export const truncateText = (text, maxLength = 10) => {
  if (!text) return "";
  const str = String(text).trim();
  return str.length > maxLength ? `${str.substring(0, maxLength)}...` : str;
};

/**
 * Truncate car display string (Brand - Name - Year)
 * @param {string} brandName - Car brand name
 * @param {string} carName - Car model name
 * @param {number|string} year - Car year
 * @param {number} maxLength - Maximum length for brand and car name (default: 10)
 * @returns {string} Formatted car string with truncation
 */
export const formatCarDisplay = (brandName, carName, year, maxLength = 10) => {
  const brand = truncateText(brandName, maxLength);
  const model = truncateText(carName, maxLength);
  return `${brand} - ${model} - ${year}`;
};


// maps a country name (e.g. "Oman") to the app's country_code (e.g. "OM")
export const getCountryIsoFromCountryName = (countryName) => {
  if (!countryName) return undefined;
  const normalized = countryName.trim().toLowerCase();
  const match = countries.find(
    (c) => c.country?.trim().toLowerCase() === normalized
  );
  return match?.country_code;
};